var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavouritesWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.836 2.572C22.144.196 18.118.59 15.619 3.263l-.973 1.045-.973-1.04c-2.016-2.16-6.08-3.461-9.217-.696-3.102 2.745-3.265 7.671-.49 10.641l9.558 10.232c.307.328.712.497 1.117.497s.81-.164 1.116-.497l9.558-10.232c2.786-2.97 2.623-7.896-.48-10.641z",
    fillOpacity: 0.302,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.246 1.698c-3.012-2.564-7.515-2.139-10.312.746L14.846 3.57 13.757 2.45C11.503.117 6.955-1.286 3.446 1.698-.024 4.66-.207 9.976 2.899 13.18L13.59 24.22c.343.354.796.537 1.25.537.452 0 .906-.177 1.248-.536L26.782 13.18c3.117-3.205 2.934-8.521-.536-11.483zm-.724 10.256L14.868 22.995 4.17 11.955c-2.122-2.19-2.564-6.361.425-8.909 3.028-2.586 6.587-.713 7.891.636l2.36 2.437 2.36-2.437c1.281-1.327 4.873-3.205 7.89-.636 2.984 2.542 2.548 6.714.426 8.908z",
    fill: "#FFF"
  }))));
}

export default SvgFavouritesWhite;